<script>
import { pickBy } from 'lodash-es';

export default {
  name: 'ItineraryPricesTransportSearchFeed',
  props: {
    transportSearchResults: {
      type: Array,
      default: () => [],
    },
    selectedAllotments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: 'From date' },
        { text: 'To date' },
        { text: 'Release date' },
        { text: 'Release days' },
        { text: 'PNR' },
        { text: 'Allotment' },
        { text: 'Taxes' },
        { text: 'YR (fuel)' },
        { text: 'Net fare' },
        { text: 'Total fare' },
        { text: 'Customer price' },
        { text: 'Infant' },
        { text: 'Child' },
        { text: 'Class' },
        { text: 'Inbound' },
        { text: 'Outbound' },
      ],
      outboundTitle: 'Outbound:',
      homeboundTitle: 'Homebound:',
      newTransportAllotments: [],
      searchFeedDialog: false,
    };
  },
  watch: {
    transportSearchResults: {
      deep: true,
      handler(value) {
        if (value.length) {
          this.searchFeedDialog = true;
        }
      },
    },
  },
  methods: {
    addTransport(value) {
      for (let i = 0; i < this.selectedTransports.length; i += 1) {
        if (this.selectedTransports[i] === value) {
          const newArray = this.selectedTransports.filter(element => element !== value);
          this.selectedTransports = [...newArray];
        } else {
          this.selectedTransports.push(value);
        }
      }
    },
    updateSelectedAllotments(value) {
      if (!this.selectedAllotments.find(allotment => allotment.id === value.id)) {
        this.$emit('add-transport', value);
      } else {
        this.$emit('remove-transport', value);
      }
    },
    setInboundDays(allotment) {
      const inboundDaysSet = pickBy(allotment.days.inbound, (value => value));
      const inboundDayKeys = Object.keys(inboundDaysSet);
      if (inboundDayKeys.length === 6) {
        return 'All days';
      }
      const days = inboundDayKeys.map(element => element.substring(0, 3));
      return days.join(', ');
    },
    setOutboundDays(allotment) {
      const outboundDaysSet = pickBy(allotment.days.outbound, (value => value));
      const outboundDayKeys = Object.keys(outboundDaysSet);
      if (outboundDayKeys.length === 6) {
        return 'All days';
      }
      const days = outboundDayKeys.map(element => element.substring(0, 3));
      return days.join(', ');
    },
    save() {
      this.searchFeedDialog = false;
      this.newTransportAllotments = [];
    },
  },
};
</script>

<template>
  <div class="wrapper text-xs-center">
    <v-dialog
      v-model="searchFeedDialog"
      width="1850"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Transport search results
        </v-card-title>

        <v-card
          class="mr-2 ml-2"
          v-for="(transport, index) in transportSearchResults"
          :key="index"
        >
          <div class="ml-4 mt-4 pt-4">
            <v-layout column>
              <v-flex xs4>
                {{ transport.transport.route }}
              </v-flex>
              <v-flex xs2>
                Remaining allotments: {{ transport.amount }}
              </v-flex>
            </v-layout>
          </div>
          <v-data-table
            :headers="headers"
            :items="[transport]"
            hide-actions
            disable-initial-sort
          >
            <template v-slot:items="props">
              <tr
                :class="[
                  { 'selected-transport' : selectedAllotments.some(e => e.id === transport.id) },
                  { 'selected-transport' : newTransportAllotments.some(e => e.id === transport.id) }
                ]"
                @click="updateSelectedAllotments(props.item)"
              >
                <td>
                  {{ props.item.fromDate }}
                </td>
                <td>
                  {{ props.item.toDate }}
                </td>
                <td>
                  {{ props.item.releaseDate }}
                </td>
                <td>
                  {{ props.item.releaseDate }}
                </td>
                <td>
                  {{ props.item.PNR }}
                </td>
                <td>
                  {{ props.item.amount }}
                </td>
                <td>
                  {{ props.item.fares.tax }}
                </td>
                <td>
                  {{ props.item.fares.fuel }}
                </td>
                <td>
                  {{ props.item.fares.net }}
                </td>
                <td>
                  {{ props.item.fares.total }}
                </td>
                <td>
                  {{ props.item.prices.adult }}
                </td>
                <td>
                  {{ props.item.prices.infant }}
                </td>
                <td>
                  {{ props.item.prices.child }}
                </td>
                <td>
                  {{ props.item.classType }}
                </td>
                <td>
                  {{ setInboundDays(props.item) }}
                </td>
                <td>
                  {{ setOutboundDays(props.item) }}
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-divider />
        </v-card>
        <v-card-actions class="fixed-action">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="searchFeedDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped lang="scss">
  @import '../../../assets/scss/variables';

  .divider {
    width: 100%;
    border: 1px solid $brand-grey-light;
    margin-bottom: $margin-xl;
  }

  .selected-transport {
    background-color: $highlight-color-green;
  }
</style>



// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesTransportSearchFeed.vue